export default "__VITE_ASSET__feb74261__"